import FrequentAsk from "./FrequentAsk";

export default FrequentAsk;
